import { Component, Ref, Prop} from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class FindABoxModal extends ThemeComponent {

}
